<div class="absolute inset-0 bg-gray-200"></div>

<layout-page-container>
  <layout-header-container title="Unternehmensübersicht"></layout-header-container>
  <layout-page-scrollable>
    <div class="">
      <div class="mt-8">
        <div class="">
          <div class="inline-block py-2 align-middle min-w-full">
            <div class="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                <tr>
                  <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" scope="col">Name
                  </th>
                  <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Title</th>
                  <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Email</th>
                  <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Role</th>
                  <th class="relative py-3.5 pl-3 pr-4 sm:pr-6" scope="col">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Lindsay
                    Walton
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Front-end Developer</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">lindsay.walton.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Member</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span
                      class="sr-only">, Lindsay Walton</span></a>
                  </td>
                </tr>
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Courtney
                    Henry
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Designer</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">courtney.henry.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Admin</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span
                      class="sr-only">, Courtney Henry</span></a>
                  </td>
                </tr>
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Tom Cook</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Director of Product</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">tom.cook.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Member</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span
                      class="sr-only">, Tom Cook</span></a>
                  </td>
                </tr>
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Whitney
                    Francis
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Copywriter</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">whitney.francis.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Admin</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span class="sr-only">, Whitney Francis</span></a>
                  </td>
                </tr>
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Leonard
                    Krasner
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Senior Designer</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">leonard.krasner.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Owner</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span class="sr-only">, Leonard Krasner</span></a>
                  </td>
                </tr>
                <tr>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Floyd Miles
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Principal Designer</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">floyd.milesexample.com</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Member</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a class="text-indigo-600 hover:text-indigo-900" href="#">Edit<span
                      class="sr-only">, Floyd Miles</span></a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-page-scrollable>
</layout-page-container>
